import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_d9x7wck94x: FaireBrandEntity = {
  token: "b_d9x7wck94x",
  type: "brand",
  name: "Real Happy Designs",
  avatarUrl:
    "https://cdn.faire.com/fastly/5c40f368ff1eb05f2a835fe4e664ba6046914f37587737109b5799622e6c4ab0.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/88ca48151902989ad4cbcb4791b0e1335be4457d620884414ca775bb5f78bba2.png",
  logoUrl:
    "https://cdn.faire.com/fastly/5c40f368ff1eb05f2a835fe4e664ba6046914f37587737109b5799622e6c4ab0.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/88ca48151902989ad4cbcb4791b0e1335be4457d620884414ca775bb5f78bba2.png",
  location: "Taber, AB, CAN",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 4,
  isInsider: false,
  description:
    "Real Happy Designs began from a love for lettering and illustrations, which genuinely makes me happy. All of our designs are created in house and produced into greeting cards, stickers and other happy little gifts. Real Happy cards are full of puns and are created with gift giving in mind. Small gifts and cards that are sure to brighten anyone's day. \n\nWe are forever coming up with new designs, so stay tuned to our shop to see what new products we have. ",
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:56:11.415Z",
    importedBy: "entity-db-cli",
  },
};
